import React from 'react';
import styled from 'styled-components';

import subtaskIcon from '../../../assets/img/icons/subtask.svg';
import ComponentCircleLoader from '../../../components/Loaders/ComponentCircleLoader';
import { CommonFlex, CommonGrid } from '../../../styledComponents/common';
import { TextBadge } from '../dashboardStyles';
import CampContent from './CampContent';

// bg-white rounded-2xl shadow-sm overflow-hidden flex flex-col
// border: 1px solid rgb(229, 231, 235);
const CardContainer = styled.div`
  background-color: white;
  border-radius: 1rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #e5e7eb;
`;

// px-5 py-3 flex items-center gap-2.5
// border-bottom: 1px solid #f3f4f6;
const CardHeader = styled.div`
  padding: 0.75rem 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  border-bottom: 1px solid #f3f4f6;
`;

// w-7 h-7 rounded-lg flex items-center justify-center
// background-color: rgb(243, 244, 246);
const LocationImageContainer = styled.div`
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f4f6;
`;

// font-size: 13px; font-weight: 600; color: #4f3423;
const SubTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #4f3423;
`;
// ml-auto text-[11px] px-2 py-0.5 rounded-full
// background-color: rgb(243, 244, 246); color: rgb(107, 114, 128);
const SubTitleBadge = styled.span`
  margin-left: auto;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  background-color: #f3f4f6;
  color: #6b7280;
`;

// flex items-baseline gap-1
const SubtaskCountContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
`;

const SubtaskCountNumber = styled.span`
  font-size: 20px;
  font-weight: 800;
  color: ${({ color }) => color};
  line-height: 1;
`;

const SubtaskCountLabel = styled.span`
  font-size: 10px;
  color: rgb(156, 163, 175);
`;

// h-full rounded-full transition-all
const ProgressBarFill = styled.div`
  height: 8px;
  border-radius: 12px;
  background-color: ${({ bgColor }) => bgColor || '#f3f4f6'};
  width: ${({ percentage, outer }) => (outer ? '100%' : `${percentage}%`)};
  transition: ${({ outer }) => (outer ? 'none' : 'width 0.3s ease-in-out')};
`;

// grid grid-cols-3 divide-x divide-gray-100 flex-1
const SubtaskContent = ({ color, badge, total, active }) => {
  return (
    <CommonGrid width="100%" columns="1fr" gap="8px">
      <CommonFlex
        alignItems="center"
        justifyContent="space-between"
        padding="0"
        width="100%"
      >
        <TextBadge color={color}>{badge}</TextBadge>
        <SubtaskCountContainer>
          <SubtaskCountNumber color={color}>{active}</SubtaskCountNumber>
          <SubtaskCountLabel>subtasks</SubtaskCountLabel>
        </SubtaskCountContainer>
      </CommonFlex>

      <ProgressBarFill outer>
        <ProgressBarFill
          percentage={total ? (active / total) * 100 : 0}
          bgColor={color}
        />
      </ProgressBarFill>
    </CommonGrid>
  );
};

const SubtaskCard = ({ statusData, loading }) => {
  const COLOR_MAP = {
    Mina: '#0d9488',
    Arafat: '#0ea5e9',
    Muzdalifah: '#f59e0b',
  };

  return (
    <CardContainer>
      <CardHeader>
        <LocationImageContainer>
          <img src={subtaskIcon} alt="Location Icon" />
        </LocationImageContainer>
        <SubTitle>Updated Subtasks</SubTitle>
        <SubTitleBadge>Today</SubTitleBadge>
      </CardHeader>

      {loading ? (
        <ComponentCircleLoader padding="0" />
      ) : statusData?.length == 0 ? (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          No data available
        </div>
      ) : (
        <CommonFlex
          padding="16px 20px"
          gap="20px"
          direction="column"
          justifyContent="center"
        >
          {/* Card content goes here */}
          {statusData?.map(item => (
            <SubtaskContent
              badge={'@' + item.public_zone_name}
              color={COLOR_MAP[item.public_zone_name]}
              total={item.total_subtasks}
              active={item.updated_today}
            />
          ))}
        </CommonFlex>
      )}
    </CardContainer>
  );
};

export default SubtaskCard;
